
import { Edit, required, SimpleForm, TextInput, useRecordContext, useTranslate } from "react-admin";
import { EditToolbar } from "../../common/EditToolbar";
import useIsPermission from '../../hooks/useIsPermission';

const FaqCategoriesEdit = () => {
    const { isUpdatable } = useIsPermission("FAQS");
    return (
        <Edit mutationMode={'pessimistic'} title={<FaqCategoriesTitle />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Edit>
    )
}

const FaqCategoriesTitle = () => {
    const record = useRecordContext<any>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.faq_categories.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default FaqCategoriesEdit;
